
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Contact } from "@/components/companies/contacts/types";

export const useCompanyContactsList = (companyId: string | undefined) => {
  const [contacts, setContacts] = useState<Contact[]>([]);
  const [contactsLoading, setContactsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [viewMode, setViewMode] = useState<'list' | 'card'>('card');
  
  const fetchContacts = async () => {
    if (!companyId) return;
    
    try {
      setContactsLoading(true);
      
      const { data, error } = await supabase
        .from('contacts')
        .select('id, first_name, last_name, function, email, phone, notes, name')
        .eq('company_id', companyId);
      
      if (error) throw error;
      
      if (data) {
        setContacts(data);
      }
    } catch (error) {
      console.error("Error fetching company contacts:", error);
      setContacts([]);
    } finally {
      setContactsLoading(false);
    }
  };
  
  useEffect(() => {
    fetchContacts();
  }, [companyId]);
  
  const filteredContacts = contacts.filter(contact => {
    if (!searchTerm) return true;
    
    const term = searchTerm.toLowerCase();
    return (
      contact.first_name.toLowerCase().includes(term) ||
      (contact.last_name && contact.last_name.toLowerCase().includes(term)) ||
      (contact.function && contact.function.toLowerCase().includes(term)) ||
      (contact.email && contact.email.toLowerCase().includes(term)) ||
      (contact.phone && contact.phone.toLowerCase().includes(term)) ||
      (contact.notes && contact.notes.toLowerCase().includes(term))
    );
  });
  
  return {
    contacts: filteredContacts,
    contactsLoading,
    searchTerm,
    setSearchTerm,
    viewMode,
    setViewMode,
    refreshContacts: fetchContacts
  };
};
